@if (data) {
  <div id="login-container">
    <div class="header">
      <div class="logo">
        <img src="../../../assets/organisation/images/logo-auth.svg" [alt]="'IMAGE_ALT.LOGO' | translate" />
      </div>
    </div>

    <div class="inner">
      @if (!isLoading) {
        <p [innerHTML]="(!data.showOTP ? 'DIALOG.TIMEOUT.LEADTEXT.LOGIN' : 'DIALOG.TIMEOUT.LEADTEXT.OTP') | translate"></p>
      }

      @if (!isLoading && !data.showOTP) {
        <form (submit)="login()">
          <div class="field field-prefix" #usernameRef>
            <label>{{ "LOGIN.USERNAME" | translate }}</label>
            <app-prefix-oms #username [counter]="false" [placeholder]="'LOGIN.USERNAME' | translate" autocomplete="username" />
          </div>

          <div class="field field-prefix" #passwordRef>
            <label>{{ "LOGIN.PASSWORD" | translate }}</label>
            <app-prefix-wac #password [placeholder]="'LOGIN.PASSWORD' | translate" autocomplete="current-password" />
          </div>

          <button type="submit" id="login-button" [disabled]="isLoading">
            {{ "LOGIN.SUBMIT" | translate }}
          </button>
          <div class="link">
            <button type="button" (click)="logout()">{{ "DIALOG.TIMEOUT.LOGOUT" | translate }}</button>
          </div>
        </form>
      }

      @if (data.showOTP && !isLoading) {
        <form (submit)="loginOTP()">
          <div class="field field-prefix" #otpRef>
            <label>{{ "LOGIN.OTP" | translate }}</label>
            <app-prefix-oms #otp [counter]="false" [placeholder]="'LOGIN.OTP' | translate" autocomplete="one-time-code" />
          </div>

          <button type="submit" id="otp-button" [disabled]="isLoading">
            {{ "LOGIN.SUBMIT_OTP" | translate }}
          </button>
          <div class="link">
            <button type="button" (click)="logout()">{{ "DIALOG.TIMEOUT.LOGOUT" | translate }}</button>
          </div>
        </form>
      }

      @if (isLoading) {
        <div id="loading-container">
          <mat-progress-spinner [color]="'primary'" [diameter]="48" [mode]="'indeterminate'" />
        </div>
      }
    </div>
  </div>
}
